import { render, staticRenderFns } from "./StaffArchivedPage.vue?vue&type=template&id=3f32c832&scoped=true&"
import script from "./StaffArchivedPage.vue?vue&type=script&lang=js&"
export * from "./StaffArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f32c832",
  null
  
)

export default component.exports